module.exports = __webpack_public_path__ + "static/media/A1-2-Droypper-cod84.ee72a4bb.png";